import * as React from 'react';

function SvgStackedLinesIndentedIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 7h12v2H6zm0 3h10v2H6zm0 3h10v2H6zm0 3h8v2H6z"
        fill="#1A1A1A"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgStackedLinesIndentedIcon;
